<template>
  <b-card header="Credit Finance Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
    <div v-if="!e_finance && isPayrollCrm" class="row">
      <!-- Is Genius applying for credit -->
      <div class="col-xl-6 form-group">
        <label class="form-label" for="finance_applying_for_credit">Is Genius applying for credit</label>
        <p id="finance_applying_for_credit" v-html="return_payroll_applying_for_credit"></p>
      </div>
      <!-- Is Genius credit approved -->
      <div v-if="isPayrollApplyingForCredit" class="col-xl-6 form-group">
        <label class="form-label" for="finance_credit_approved">Is credit approved</label>
        <p id="finance_credit_approved" v-html="return_payroll_credit_approved"></p>
      </div>
      <!-- Genius Credit Amount -->
      <div v-if="isPayrollCreditApproved" class="col-xl-6 form-group">
        <label class="form-label" for="finance_credit_amount">Genius Credit Amount</label>
        <p id="finance_credit_amount" v-html="return_payroll_credit_amount"></p>
      </div>
      <!-- Genius Credit Date -->
      <div v-if="isPayrollCreditApproved" class="col-xl-6 form-group">
        <label class="form-label" for="finance_credit_date">Date Genius credit approved</label>
        <p id="finance_credit_date" v-html="return_payroll_credit_date"></p>
      </div>
      <div class="col-12 text-right" v-if="ifNotCompanyContactUser">
        <button @click="edit_form" class="btn orcaBtn blueBtn sm_btn mb-2" style="width: auto !important;">Edit Finance Information</button>
      </div>
    </div>
    <div v-else-if="e_finance && isPayrollCrm" class="row">
      <div class="col-12">
        <ValidationObserver ref="editFinanceForm" slim>
          <form role="form" @submit.prevent="submit_form">
            <div class="row">
              <!-- Is Genius applying for credit -->
              <div class="col-xl-6">
                <div class="row">
                  <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_finance_applying_for_credit">
                    Is Genius applying for credit</label>
                  <div class="col-md-4 form-group">
                    <bootstrap-toggle v-model="edit_credit_finance.payroll_applying_for_credit" id="edit_finance_applying_for_credit" name="edit_finance_applying_for_credit"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                  </div>
                </div>
              </div>
              <!-- Is Genius credit approved -->
              <div v-if="isEditFormPayrollApplyingForCredit" class="col-xl-6">
                <div class="row">
                  <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_finance_credit_approved">Is Genius credit approved</label>
                  <div class="col-md-4 form-group">
                    <bootstrap-toggle v-model="edit_credit_finance.payroll_credit_approved" id="edit_finance_credit_approved" name="edit_finance_credit_approved"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                  </div>
                </div>
              </div>
              <!-- Genius Credit Amount -->
              <ValidationProvider v-if="isEditFormPayrollCreditApproved"
                                  rules="decimal" v-slot="{errors, classes}" name="Credit Amount" tag="div" class="col-xl-6 form-group">
                <label class="form-label" for="edit_finance_credit_amount">Credit Amount</label>
                <div class="input-group">
                  <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                  <input type="text" v-model="edit_credit_finance.payroll_credit_amount" id="edit_finance_credit_amount" name="edit_finance_credit_amount" class="form-input"
                         :class="classes">
                </div>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <!-- Genius Credit Date -->
              <ValidationProvider v-if="isEditFormPayrollCreditApproved"
                                  rules="" v-slot="{errors, classes}" name="Date of Birth" tag="div" class="col-xl-6 form-group">
                <label class="form-label" for="edit_finance_credit_date">Credit Approved Date</label>
                <datepicker v-model="edit_credit_finance.payroll_credit_date" id="edit_finance_credit_date" name="edit_finance_credit_date"
                            :input-class="['date-input', classes]" :format="dateFormat" :clear-button="true"
                            clear-button-icon="far fa-calendar-times" @input="select_finance_credit_date" :use-utc="true"></datepicker>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
            <div class="row mb-3">
              <div class="col-xl-6">
                <button @click.prevent="cancel_form" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
              </div>
              <div class="col-xl-6">
                <button type="submit" class="btn orcaBtn sm_btn w-100">Update information</button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <div v-else-if="!e_finance && isRecruitmentCrm" class="row">
      <!-- Is V3 applying for credit -->
      <div class="col-xl-6 form-group">
        <label class="form-label" for="v3_finance_applying_for_credit">Is V3 applying for credit</label>
        <p id="v3_finance_applying_for_credit" v-html="return_recruitment_applying_for_credit"></p>
      </div>
      <!-- Is V3 credit approved -->
      <div v-if="isRecruitmentApplyingForCredit" class="col-xl-6 form-group">
        <label class="form-label" for="v3_finance_credit_approved">Is credit approved</label>
        <p id="v3_finance_credit_approved" v-html="return_recruitment_credit_approved"></p>
      </div>
      <!-- V3 Credit Amount -->
      <div v-if="isRecruitmentCreditApproved" class="col-xl-6 form-group">
        <label class="form-label" for="v3_finance_credit_amount">V3 Credit Amount</label>
        <p id="v3_finance_credit_amount" v-html="return_recruitment_credit_amount"></p>
      </div>
      <!-- V3 Credit Date -->
      <div v-if="isRecruitmentCreditApproved" class="col-xl-6 form-group">
        <label class="form-label" for="v3_finance_credit_date">Date V3 credit approved</label>
        <p id="v3_finance_credit_date" v-html="return_recruitment_credit_date"></p>
      </div>
      <div class="col-12 text-right" v-if="ifNotCompanyContactUser">
        <button @click="edit_form" class="btn orcaBtn blueBtn sm_btn mb-2" style="width: auto !important;">Edit Finance Information</button>
      </div>
    </div>
    <div v-else-if="e_finance && isRecruitmentCrm" class="row">
      <div class="col-12">
        <ValidationObserver ref="editFinanceForm" slim>
          <form role="form" @submit.prevent="submit_form">
            <div class="row">
              <!-- Is V3 applying for credit -->
              <div class="col-xl-6">
                <div class="row">
                  <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_v3_finance_applying_for_credit">
                    Is V3 applying for credit</label>
                  <div class="col-md-4 form-group">
                    <bootstrap-toggle v-model="edit_credit_finance.recruitment_applying_for_credit" id="edit_v3_finance_applying_for_credit"
                                      name="edit_v3_finance_applying_for_credit" :options="{ on: 'Yes', off: 'No' }"/>
                  </div>
                </div>
              </div>
              <!-- Is V3 credit approved -->
              <div v-if="isEditFormRecruitmentApplyingForCredit" class="col-xl-6">
                <div class="row">
                  <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="edit_v3_finance_credit_approved">Is V3 credit approved</label>
                  <div class="col-md-4 form-group">
                    <bootstrap-toggle v-model="edit_credit_finance.recruitment_credit_approved" id="edit_v3_finance_credit_approved" name="edit_v3_finance_credit_approved"
                                      :options="{ on: 'Yes', off: 'No' }"/>
                  </div>
                </div>
              </div>
              <!-- V3 Credit Amount -->
              <ValidationProvider v-if="isEditFormRecruitmentCreditApproved"
                                  rules="decimal" v-slot="{errors, classes}" name="V3 Credit Amount" tag="div" class="col-xl-6 form-group">
                <label class="form-label" for="edit_v3_finance_credit_amount">Credit Amount</label>
                <div class="input-group">
                  <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                  <input type="text" v-model="edit_credit_finance.recruitment_credit_amount" id="edit_v3_finance_credit_amount" name="edit_v3_finance_credit_amount"
                         class="form-input" :class="classes">
                </div>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <!-- V3 Credit Date -->
              <ValidationProvider v-if="isEditFormRecruitmentCreditApproved"
                                  rules="" v-slot="{errors, classes}" name="Credit Approved Date" tag="div" class="col-xl-6 form-group">
                <label class="form-label" for="edit_v3_finance_credit_date">Credit Approved Date</label>
                <datepicker v-model="edit_credit_finance.recruitment_credit_date" id="edit_v3_finance_credit_date" name="edit_v3_finance_credit_date"
                            :input-class="['date-input', classes]" :format="dateFormat" :clear-button="true"
                            clear-button-icon="far fa-calendar-times" @input="select_finance_credit_date" :use-utc="true"></datepicker>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
            <div class="row mb-3">
              <div class="col-xl-6">
                <button @click.prevent="cancel_form" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
              </div>
              <div class="col-xl-6">
                <button type="submit" class="btn orcaBtn sm_btn w-100">Update information</button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </b-card>
</template>

<script>
import BootstrapToggle from 'vue-bootstrap-toggle';
import Datepicker from 'vuejs-datepicker';
import { getChangedFields } from 'utils/utils';

export default {
  name: "credit_finance",
  components: {
    BootstrapToggle,
    Datepicker
  },
  props: [
    'ifNotCompanyContactUser',
    'isPayrollCrm',
    'isRecruitmentCrm',
    'credit_finance',
    'company'
  ],
  data() {
    return {
      e_finance: false,
      edit_credit_finance: {},
      original_credit_finance: {},
    }
  },
  computed: {
    /* ---------------------------------------------------------------------------------------------------------
     * PAYROLL CRM - view data
     * ---------------------------------------------------------------------------------------------------------
     */
    /**
     * Return value for if on the payroll crm the company is applying for credit terms
     * @returns {string}
     */
    return_payroll_applying_for_credit() {
      if (this.credit_finance.payroll_applying_for_credit) {
        return "Yes"
      }
      else if (!this.credit_finance.payroll_applying_for_credit) {
        return "No"
      }
      else return "&nbsp;"
    },
    /**
     * On payroll crm - is credit being applied for
     * @returns {boolean}
     */
    isPayrollApplyingForCredit() {
      return this.credit_finance.payroll_applying_for_credit
    },
    /**
     * Return value for if on the payroll crm the company has had credit agreed
     * @returns {string}
     */
    return_payroll_credit_approved() {
      if (this.credit_finance.payroll_credit_approved) {
        return "Yes"
      }
      else if (!this.credit_finance.payroll_credit_approved) {
        return "No"
      }
      else return "&nbsp;"
    },
    /**
     * On payroll crm - has credit been approved
     * @returns {boolean}
     */
    isPayrollCreditApproved() {
      return this.credit_finance.payroll_credit_approved
    },
    /**
     * On payroll crm - Return formatted credit amount agreed
     * @returns {string|*}
     */
    return_payroll_credit_amount() {
      if (this.credit_finance.payroll_credit_amount !== null) {
        return this.$options.filters.currency(this.credit_finance.payroll_credit_amount)
      }
      else return "&nbsp;"
    },
    /**
     * On payroll crm - Return formatted credit agreed date
     * @returns {string|*}
     */
    return_payroll_credit_date() {
      if (this.credit_finance.payroll_credit_date !== null) {
        return this.$options.filters.formatDate(this.credit_finance.payroll_credit_date)
      }
      else return "&nbsp;"
    },
    /* ---------------------------------------------------------------------------------------------------------
     * PAYROLL CRM - edit form
     * ---------------------------------------------------------------------------------------------------------
     */
    /**
     * If on payroll crm edit form - applying for credit
     * @returns {boolean}
     */
    isEditFormPayrollApplyingForCredit() {
      return this.notEmptyObject(this.edit_credit_finance) && this.edit_credit_finance.payroll_applying_for_credit
    },
    /**
     * If on payroll crm edit form - is credit approved
     * @returns {boolean}
     */
    isEditFormPayrollCreditApproved() {
      return this.notEmptyObject(this.edit_credit_finance) && this.edit_credit_finance.payroll_credit_approved
    },
    /* ---------------------------------------------------------------------------------------------------------
     * RECRUITMENT CRM - view data
     * ---------------------------------------------------------------------------------------------------------
     */
    /**
     * Return value for if on the recruitment crm the company is applying for credit terms
     * @returns {string}
     */
    return_recruitment_applying_for_credit() {
      if (this.credit_finance.recruitment_applying_for_credit) {
        return "Yes"
      }
      else if (!this.credit_finance.recruitment_applying_for_credit) {
        return "No"
      }
      else return "&nbsp;"
    },
    /**
     * On recruitment crm - is credit being applied for
     * @returns {boolean}
     */
    isRecruitmentApplyingForCredit() {
      return this.credit_finance.recruitment_applying_for_credit
    },
    /**
     * Return value for if on the recruitment crm the company has had credit agreed
     * @returns {string}
     */
    return_recruitment_credit_approved() {
      if (this.credit_finance.recruitment_credit_approved) {
        return "Yes"
      }
      else if (!this.credit_finance.recruitment_credit_approved) {
        return "No"
      }
      else return "&nbsp;"
    },
    /**
     * On recruitment crm - has credit been approved
     * @returns {boolean}
     */
    isRecruitmentCreditApproved() {
      return this.notEmptyObject(this.credit_finance) && this.credit_finance.recruitment_credit_approved
    },
    /**
     * On recruitment crm - Return formatted credit amount agreed
     * @returns {string|*}
     */
    return_recruitment_credit_amount() {
      if (this.credit_finance.recruitment_credit_amount !== null) {
        return this.$options.filters.currency(this.credit_finance.recruitment_credit_amount)
      }
      else return "&nbsp;"
    },
    /**
     * On recruitment crm - Return formatted credit agreed date
     * @returns {string|*}
     */
    return_recruitment_credit_date() {
      if (this.credit_finance.recruitment_credit_date !== null) {
        return this.$options.filters.formatDate(this.credit_finance.recruitment_credit_date)
      }
      else return "&nbsp;"
    },
    /* ---------------------------------------------------------------------------------------------------------
     * RECRUITMENT CRM - edit form
     * ---------------------------------------------------------------------------------------------------------
     */
    /**
     * If on recruitment crm edit form - applying for credit
     * @returns {boolean}
     */
    isEditFormRecruitmentApplyingForCredit() {
      return this.notEmptyObject(this.edit_credit_finance) && this.edit_credit_finance.recruitment_applying_for_credit
    },
    /**
     * If on payroll crm edit form - is credit approved
     * @returns {boolean}
     */
    isEditFormRecruitmentCreditApproved() {
      return this.notEmptyObject(this.edit_credit_finance) && this.edit_credit_finance.recruitment_credit_approved
    },
  },
  methods: {
    /**
     * Switch vue to show form to edit credit finance information
     * and set values on form
     */
    edit_form() {
      this.edit_credit_finance = Object.assign({}, this.credit_finance);
      this.original_credit_finance = Object.assign({}, this.credit_finance); 
      this.$nextTick(() => this.e_finance = true)
    },
    /**
     * Reset and hide the edit form
     */
    cancel_form() {
      this.edit_credit_finance = {};
      this.e_finance = false;
    },
    /**
     * Submit the edit form values to the database and reload vue
     */
    submit_form() {
      this.$refs.editFinanceForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editFinanceForm);
        }
        else {
          this.$store.commit('SET_UPDATE_COMPANY_ID', this.company.id);
          let submit_cf = {};

          
          // Use the new function to get changed fields
          let changed_fields = [
            ...getChangedFields(this.original_credit_finance, this.edit_credit_finance),
          ];


          if (this.isPayrollCrm) {
            submit_cf = {
              company_id: this.company.id,
              payroll_applying_for_credit: this.edit_credit_finance.payroll_applying_for_credit,
              payroll_credit_approved: this.edit_credit_finance.payroll_credit_approved,
              payroll_credit_amount: this.edit_credit_finance.payroll_credit_amount,
              payroll_credit_date: this.edit_credit_finance.payroll_credit_date,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            }
          }
          else if (this.isRecruitmentCrm) {
            submit_cf = {
              company_id: this.company.id,
              recruitment_applying_for_credit: this.edit_credit_finance.recruitment_applying_for_credit,
              recruitment_credit_approved: this.edit_credit_finance.recruitment_credit_approved,
              recruitment_credit_amount: this.edit_credit_finance.recruitment_credit_amount,
              recruitment_credit_date: this.edit_credit_finance.recruitment_credit_date,
              log_by_type: 'App\\Models\\Users\\User',
              log_by_id: this.$store.state.auth.me.id
            }
          }
          // No credit finance information exists - save as new to database
          if (!this.notEmptyObject(this.credit_finance) || this.credit_finance === '' || Object.keys(this.credit_finance).length <= 1) {
            axios.post(this.crmApiPath + 'company/credit_finance', submit_cf).then(() => {
              this.$bus.$emit('company::reload', {action: true});
              this.$bus.$emit('company_credit_finance::reload', {action: true});
              this.$bus.$emit('logs::reload', {action: true});
              // close form
              this.$nextTick(() => {
                this.e_finance = false;
                this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
              });
            })
          }
          // credit finance information does already exist - update to database
          else {
            axios.patch(this.crmApiPath + 'company/credit_finance/' + this.credit_finance.id, submit_cf).then(() => {
              this.$bus.$emit('company::reload', {action: true});
              this.$bus.$emit('company_credit_finance::reload', {action: true});
              this.$bus.$emit('logs::reload', {action: true});
              // close form
              this.$nextTick(() => {
                this.e_finance = false;
                this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
              });
            })
          }

          
          if (changed_fields.length > 0) {
            // Send changed fields through AJAX on email
              axios.post(this.crmApiPath + 'company/send_changed_email', {
                title: 'CREDIT FINANCE INFORMATION',
                company_id: this.company.id,
                changes: changed_fields,
              });
          }


        }
      });
    },
    /* ---------------------------------------------------------------------------------------------------------
     * edit form
     * ---------------------------------------------------------------------------------------------------------
     */
    /**
     * Return selected date formatted for datepicker
     * @param date
     * @returns {string}
     */
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    /**
     * Format date for edit values when selected in datepicker
     * @param date
     */
    select_finance_credit_date(date) {
      if (date !== null && this.isPayrollCrm) {
        this.edit_credit_finance.payroll_credit_date = this.$moment.utc(date).format('YYYY-MM-DD');
      }
      if (date !== null && this.isRecruitmentCrm) {
        this.edit_credit_finance.recruitment_credit_date = this.$moment.utc(date).format('YYYY-MM-DD');
      }
    },
  },
  watch: {
    'edit_credit_finance.payroll_applying_for_credit'(val) {
      if (!val) {
        this.edit_credit_finance.payroll_credit_approved = false;
      }
    },
    'edit_credit_finance.payroll_credit_approved'(val) {
      if (!val) {
        this.edit_credit_finance.payroll_credit_amount = '';
        this.edit_credit_finance.payroll_credit_date = null;
      }
    },
    'edit_credit_finance.recruitment_applying_for_credit'(val) {
      if (!val) {
        this.edit_credit_finance.recruitment_credit_approved = false;
      }
    },
    'edit_credit_finance.recruitment_credit_approved'(val) {
      if (!val) {
        this.edit_credit_finance.recruitment_credit_amount = '';
        this.edit_credit_finance.recruitment_credit_date = null;
      }
    },
  }
}
</script>
